module.exports = __webpack_public_path__ + "static/img/19053B_3_R_20201008_fit.d3355ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19053B_3_R_20201008_fit.png
// module id = bY3q
// module chunks = 0